<wbo-edit-page #editPage [title]="model.data.details.name">
    <fui-formation-group [title]="'wbo.screen-layout.edit.formation.details'" [formControlNames]="''">
        <fui-rows [formGroup]="editPage.formGroup">
            <fui-row>
                <fui-two-columns formGroupName="details">
                    <fui-column>
                        <wbo-text-edit-control formControlName="name" [(ngModel)]="model.data.details.name">
                        </wbo-text-edit-control>
                        <ng-container formGroupName="courses">
                            <wbo-course-definition-single-select-edit-control formControlName="id"
                                                                              [objectValue]="model.data.details.courses"
                                                                              [(ngModel)]="model.data.details.courses.id">
                            </wbo-course-definition-single-select-edit-control>
                        </ng-container>
                    </fui-column>
                    <fui-column>
                        <wbo-textarea-edit-control formControlName="description" [(ngModel)]="model.data.details.description">
                        </wbo-textarea-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <wbo-screen-layout-editor [courseDefinitionId]="model.data.details.courses.id"></wbo-screen-layout-editor>
            </fui-row>
        </fui-rows>
    </fui-formation-group>
</wbo-edit-page>
